function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.76,
    height: 9.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6116666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 4.835
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.67,
    width: 18.76,
    height: 10.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5214285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 14.995000000000001
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.32,
    width: 18.76,
    height: 11.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.121
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 25.925
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.53,
    width: 18.76,
    height: 11.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 37.230000000000004
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.93,
    width: 18.76,
    height: 11.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 48.63
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.33,
    width: 18.76,
    height: 11.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9069230769230768
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 60.224999999999994
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.12,
    width: 18.76,
    height: 14.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 73.29
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.47,
    width: 18.76,
    height: 15.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 88.25
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.02,
    width: 18.76,
    height: 19.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7520000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 105.74499999999999
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.48,
    width: 18.76,
    height: 19.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 125.385
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.29,
    width: 18.76,
    height: 20.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 145.58499999999998
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 155.88,
    width: 18.76,
    height: 21.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 166.45
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 177.02,
    width: 18.76,
    height: 22.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 188.21
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 199.41,
    width: 18.76,
    height: 22.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 210.6
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 221.79,
    width: 18.76,
    height: 23.45,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 233.515
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 245.24,
    width: 18.76,
    height: 23.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 257.16
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.08,
    width: 18.76,
    height: 24.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 281.315
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 293.55,
    width: 18.76,
    height: 28.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 307.785
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 322.03,
    width: 18.76,
    height: 28.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 336.48499999999996
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 350.93,
    width: 18.76,
    height: 29.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 365.54
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 380.15,
    width: 18.76,
    height: 29.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 395.015
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.88,
    width: 18.76,
    height: 30.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8760000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 425.29
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 440.71,
    width: 18.76,
    height: 30.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 456.18
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 471.65,
    width: 18.76,
    height: 31.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7520000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 487.16999999999996
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 502.69,
    width: 18.76,
    height: 31.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7520000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 518.52
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 534.35,
    width: 18.76,
    height: 32.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 550.57
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 566.79,
    width: 18.76,
    height: 32.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 583.27
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 599.75,
    width: 18.76,
    height: 33.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 616.375
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 633,
    width: 18.76,
    height: 33.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 649.735
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 666.46,
    width: 18.76,
    height: 33.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.38,
    y: 683.23
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 0,
    width: 24.37,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8740000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.945,
    y: 13.515
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.13,
    y: 0,
    width: 24.99,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.625,
    y: 13.515
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.12,
    y: 0,
    width: 25.87,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.055,
    y: 13.515
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.99,
    y: 0,
    width: 25.94,
    height: 27.03,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.705714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.96,
    y: 13.515
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 0,
    width: 26.02,
    height: 27.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.93,
    y: 13.515
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 0,
    width: 26.02,
    height: 27.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.336666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.95,
    y: 13.515
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.96,
    y: 0,
    width: 26.5,
    height: 27.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.21,
    y: 13.515
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.46,
    y: 0,
    width: 26.81,
    height: 27.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.468333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.865,
    y: 13.515
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.27,
    y: 0,
    width: 26.91,
    height: 27.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.72500000000002,
    y: 13.515
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.18,
    y: 0,
    width: 27,
    height: 27.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.68,
    y: 13.515
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.19,
    y: 0,
    width: 27.43,
    height: 27.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.406000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.905,
    y: 13.515
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.62,
    y: 0,
    width: 27.58,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.406000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.41,
    y: 13.515
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.2,
    y: 0,
    width: 27.97,
    height: 27.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.185,
    y: 13.515
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.17,
    y: 0,
    width: 28.29,
    height: 27.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.37875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.315,
    y: 13.515
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.47,
    y: 0,
    width: 28.93,
    height: 27.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8614285714285717
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.935,
    y: 13.515
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.4,
    y: 0,
    width: 29.1,
    height: 27.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8614285714285717
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.95,
    y: 13.515
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 0,
    width: 30.11,
    height: 27.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.555,
    y: 13.515
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.61,
    y: 0,
    width: 30.13,
    height: 27.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.37875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.675,
    y: 13.515
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.74,
    y: 0,
    width: 30.27,
    height: 27.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.406000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.875,
    y: 13.515
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.01,
    y: 0,
    width: 31.22,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7030000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.62,
    y: 13.515
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.22,
    y: 0,
    width: 31.44,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.37875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.94,
    y: 13.515
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.66,
    y: 0,
    width: 32.66,
    height: 27.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.99,
    y: 13.515
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.33,
    y: 0,
    width: 32.8,
    height: 27.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.73,
    y: 13.515
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.13,
    y: 0,
    width: 32.87,
    height: 27.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.406000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.5649999999999,
    y: 13.515
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 27.03,
    width: 30.9,
    height: 28.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.896
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 41.510000000000005
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 55.99,
    width: 30.9,
    height: 29.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 70.755
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 85.52,
    width: 30.9,
    height: 29.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 100.475
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 115.43,
    width: 30.9,
    height: 29.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.281428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 130.41500000000002
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 145.4,
    width: 30.9,
    height: 30.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 160.775
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 176.15,
    width: 30.9,
    height: 30.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.168
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 191.57
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 206.99,
    width: 30.9,
    height: 31.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.414285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 222.74
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 238.5,
    width: 30.9,
    height: 31.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 254.31
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 270.12,
    width: 30.9,
    height: 31.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1499999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 286.015
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 301.91,
    width: 30.9,
    height: 31.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1499999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 317.90000000000003
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 333.89,
    width: 30.9,
    height: 32.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1499999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 349.90999999999997
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 365.93,
    width: 30.9,
    height: 32.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.414285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 381.96500000000003
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 397.99,
    width: 30.9,
    height: 32.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 414.045
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 430.1,
    width: 30.9,
    height: 32.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 446.185
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 462.27,
    width: 30.9,
    height: 32.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 478.465
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 494.66,
    width: 30.9,
    height: 32.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 510.86
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 527.06,
    width: 30.9,
    height: 34.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.299999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 544.0749999999999
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 561.09,
    width: 30.9,
    height: 34.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 578.26
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 595.43,
    width: 30.9,
    height: 34.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 612.625
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 629.81,
    width: 30.9,
    height: 35.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.414285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 647.3349999999999
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.76,
    y: 664.87,
    width: 30.9,
    height: 35.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.21,
    y: 682.4350000000001
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 27.03,
    width: 31.41,
    height: 36.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.365,
    y: 45.28
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.07,
    y: 27.03,
    width: 33.12,
    height: 36.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.63,
    y: 45.28
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.19,
    y: 27.03,
    width: 33.19,
    height: 36.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.741428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.785,
    y: 45.28
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.38,
    y: 27.03,
    width: 33.81,
    height: 36.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.285,
    y: 45.28
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.19,
    y: 27.03,
    width: 34.37,
    height: 36.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.874
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.375,
    y: 45.28
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.55,
    y: 27.03,
    width: 35.2,
    height: 36.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.15,
    y: 45.28
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.76,
    y: 27.03,
    width: 36.04,
    height: 36.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.148571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.78,
    y: 45.28
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.8,
    y: 27.03,
    width: 36.05,
    height: 36.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.50625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.825,
    y: 45.28
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.85,
    y: 27.03,
    width: 36.14,
    height: 36.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.228
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.92,
    y: 45.28
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.98,
    y: 27.03,
    width: 36.18,
    height: 36.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.07,
    y: 45.28
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.17,
    y: 27.03,
    width: 36.29,
    height: 36.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.315,
    y: 45.28
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.45,
    y: 27.03,
    width: 36.53,
    height: 36.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.083333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.715,
    y: 45.28
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.98,
    y: 27.03,
    width: 36.85,
    height: 36.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.40500000000003,
    y: 45.28
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.83,
    y: 27.03,
    width: 37.46,
    height: 36.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.083333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.56,
    y: 45.28
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.29,
    y: 27.03,
    width: 38.21,
    height: 36.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.055555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.395,
    y: 45.28
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.5,
    y: 27.03,
    width: 39.6,
    height: 36.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.083333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.3,
    y: 45.28
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.1,
    y: 27.03,
    width: 39.93,
    height: 36.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.065,
    y: 45.28
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.03,
    y: 27.03,
    width: 39.97,
    height: 36.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.214285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.015,
    y: 45.28
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 63.53,
    width: 40.81,
    height: 36.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 81.93
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 100.33,
    width: 40.81,
    height: 37.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.213333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 118.97
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 137.61,
    width: 40.81,
    height: 37.81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.301666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 156.51500000000001
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 175.42,
    width: 40.81,
    height: 38.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 194.545
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 213.67,
    width: 40.81,
    height: 38.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 232.89499999999998
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 252.13,
    width: 40.81,
    height: 38.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.318888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 271.565
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 291,
    width: 40.81,
    height: 38.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.792
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 310.48
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 329.95,
    width: 40.81,
    height: 39.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.345555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 349.505
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 369.06,
    width: 40.81,
    height: 39.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.675714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 388.925
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 408.79,
    width: 40.81,
    height: 40.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 428.84000000000003
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 448.88,
    width: 40.81,
    height: 40.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.734285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 468.95
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 489.02,
    width: 40.81,
    height: 41.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 509.71999999999997
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 530.42,
    width: 40.81,
    height: 41.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 551.26
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 572.1,
    width: 40.81,
    height: 41.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 593.005
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 613.91,
    width: 40.81,
    height: 42.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 635.23
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 656.55,
    width: 40.81,
    height: 43.45,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.10125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.065,
    y: 678.275
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 63.53,
    width: 41.19,
    height: 44.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.864999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.065,
    y: 85.95
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.67,
    y: 63.53,
    width: 41.96,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.64999999999998,
    y: 85.95
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.63,
    y: 63.53,
    width: 42.35,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.705555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.805,
    y: 85.95
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.98,
    y: 63.53,
    width: 42.54,
    height: 44.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.077142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.25,
    y: 85.95
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.52,
    y: 63.53,
    width: 43.58,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.263333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.31,
    y: 85.95
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.1,
    y: 63.53,
    width: 43.68,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.94,
    y: 85.95
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.78,
    y: 63.53,
    width: 44.19,
    height: 44.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.838
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.875,
    y: 85.95
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.97,
    y: 63.53,
    width: 46.3,
    height: 44.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.12,
    y: 85.95
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.27,
    y: 63.53,
    width: 50.99,
    height: 44.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.765,
    y: 85.95
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.26,
    y: 63.53,
    width: 51.09,
    height: 44.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.805,
    y: 85.95
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.35,
    y: 63.53,
    width: 52.48,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.59,
    y: 85.95
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.83,
    y: 63.53,
    width: 54.16,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.9100000000001,
    y: 85.95
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.98,
    y: 63.53,
    width: 55.02,
    height: 44.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.49,
    y: 85.95
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 108.37,
    width: 56.51,
    height: 43.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 130.325
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 152.28,
    width: 56.51,
    height: 46.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 175.745
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 199.21,
    width: 56.51,
    height: 47.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.784285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 222.955
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 246.7,
    width: 56.51,
    height: 48.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.04375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 270.875
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 295.05,
    width: 56.51,
    height: 48.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.101666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 319.355
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 343.67,
    width: 56.51,
    height: 49.57,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.081428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 368.45500000000004
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 393.23,
    width: 56.51,
    height: 57.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.072857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 421.91
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 450.59,
    width: 56.51,
    height: 58.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.06375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 479.66999999999996
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 508.75,
    width: 56.51,
    height: 62,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.072857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 539.75
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 570.75,
    width: 56.51,
    height: 62.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.418333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 602
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 633.26,
    width: 56.51,
    height: 66.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.418333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.725,
    y: 666.63
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 108.37,
    width: 60.2,
    height: 63.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.07999999999998,
    y: 140.055
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.18,
    y: 108.37,
    width: 65.28,
    height: 63.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.561666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.82,
    y: 140.055
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.46,
    y: 108.37,
    width: 65.39,
    height: 63.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.674
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.155,
    y: 140.055
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.85,
    y: 108.37,
    width: 66.4,
    height: 63.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.052857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.05,
    y: 140.055
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.25,
    y: 108.37,
    width: 71.89,
    height: 63.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.92125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.195,
    y: 140.055
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.14,
    y: 108.37,
    width: 74.06,
    height: 63.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.052857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.17,
    y: 140.055
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 108.37,
    width: 74.56,
    height: 63.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.04111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.48,
    y: 140.055
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.76,
    y: 108.37,
    width: 75.24,
    height: 63.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.674
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.38,
    y: 140.055
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 171.75,
    width: 77.1,
    height: 65.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.37142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 204.55
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 237.34,
    width: 77.1,
    height: 67.03,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.37875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 270.855
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 304.38,
    width: 77.1,
    height: 74.08,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 341.42
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 378.46,
    width: 77.1,
    height: 74.18,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.597142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 415.54999999999995
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 452.64,
    width: 77.1,
    height: 78.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 492.065
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 531.49,
    width: 77.1,
    height: 82.13,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.419999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 572.5550000000001
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.98,
    y: 613.62,
    width: 77.1,
    height: 86.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.014285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.52999999999997,
    y: 656.81
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.08,
    y: 171.75,
    width: 65.06,
    height: 105.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.61,
    y: 224.49
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.14,
    y: 171.75,
    width: 78.34,
    height: 105.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.704444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.31,
    y: 224.49
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.48,
    y: 171.75,
    width: 107.82,
    height: 105.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.39,
    y: 224.49
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.3,
    y: 171.75,
    width: 110.73,
    height: 105.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.06857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.665,
    y: 224.49
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.03,
    y: 171.75,
    width: 113.97,
    height: 105.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.015,
    y: 224.49
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.08,
    y: 277.23,
    width: 126.48,
    height: 103.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.91375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.32,
    y: 328.885
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.08,
    y: 380.54,
    width: 126.48,
    height: 131.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.068571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.32,
    y: 446.14500000000004
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.08,
    y: 511.74,
    width: 126.48,
    height: 188.26,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.32,
    y: 605.87
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.57,
    y: 277.23,
    width: 154.87,
    height: 256.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 38.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.005,
    y: 405.43500000000006
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.43,
    y: 277.23,
    width: 194.57,
    height: 256.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.428333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.715,
    y: 405.43500000000006
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.57,
    y: 533.64,
    width: 349.43,
    height: 166.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.72666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.285,
    y: 616.8199999999999
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.e6a8ebd910393c01ce8980457b875bfe.svg";
export { ForwardRef as ReactComponent };